<template>
    <v-checkbox :prepend-icon="icon"
                v-model="checked_state"
                :label="label"
                @click.prevent="change_state"
                :class="[icon !== null ? 'active-3scb' : '', current_state === 1 ? 'answered-pos': (current_state ===-1) ? '':'answered-neg']"
                :disabled="disabled"
                :rules="(cb_type === '2SCB')? [twoStateCheckedRule] : []"
    ></v-checkbox>
</template>

<script>
    export default {
        name: "ThreeStateCheckboxComponent",
        props : {
            disabled : {
              type : Boolean,
              default : false
            },
            checkbox_id: {
                type: String,
                required: true
            },
            cb_type : {
                type: String,
                default: 'DQI'
            },
            label:{
                type: String,
                required : true
            },
            state: {
                type: Number,
                default : -1
            },
            rules : {
              type: Function,
              required : false
            }
        },
        data :() => {
            return {
                icon : 'mdi-square-outline',
                checked_state : false,
                current_state: -1
            }
        },
        methods : {
            change_state(){
                switch(this.cb_type){
                    case 'DQI':
                    case '2SCB':
                        if(this.checked_state){
                            this.icon = 'mdi-check-bold';
                            this.current_state  = 1;
                        }else{
                            this.icon = 'mdi-close';
                            this.current_state = 0;
                        }
                        break;
                    case '3SCB':
                        switch (this.current_state) {
                            case -1:
                                this.icon = 'mdi-check-bold';
                                this.current_state = 1;
                                this.checked_state = true;
                                break;
                            case 0:
                                this.icon = 'mdi-square-outline';
                                this.current_state = -1;
                                this.checked_state = false;
                                break;
                            case 1:
                                this.current_state = 0;
                                this.icon = 'mdi-close';
                                this.checked_state = false;
                                break;

                        }
                        break;
                }
                this.sendState();
            },
            sendState(){
                let data = {
                    id : this.checkbox_id,
                    state : this.current_state
                };
                this.$emit('3SCBChanged', data);
            },
            twoStateCheckedRule(){
              if(this.current_state !== -1){
                return true;
              }
              return this.$vuetify.lang.t('$vuetify.global.checkbox_mandatory');
            }
        },
        watch : {
            state :{
                handler (after){
                    if(after === -1){
                        this.current_state = -1
                        this.checked_state = false;
                        this.icon = 'mdi-square-outline';
                    }
                }
            }
        },
        mounted() {
            this.sendState();
        }
    }
</script>

<style lang="scss">
    .v-input--checkbox{
        &.active-3scb{
            label{
                top:0px;
            }
            .v-input__prepend-outer{
                i{
                    padding-bottom: 4px;
                }
            }
            &.answered-pos{
                .v-input__prepend-outer{
                    i{
                        color: green !important;
                    }
                }
            }
            &.answered-neg{
                .v-input__prepend-outer{
                    i{
                        color: darkred;
                    }
                }
            }
            .v-input--selection-controls__input{
                display: none !important;
            }
            .v-input__slot{
              margin-left: -33px;
              z-index: 4;
              padding-left: 33px;
            }
            .v-messages__message{
              margin-left: -33px;
            }
        }
    }
</style>